import { render, staticRenderFns } from "./PlayerMainControls.vue?vue&type=template&id=2a44b85a&scoped=true&"
import script from "./PlayerMainControls.vue?vue&type=script&lang=js&"
export * from "./PlayerMainControls.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMainControls.vue?vue&type=style&index=0&id=2a44b85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a44b85a",
  null
  
)

export default component.exports